module.exports = __webpack_public_path__ + "media/images/client/AdCatalog/banner-search-527a87929579d84ab0d7dd4efc62063c.svg";